import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployeeHome } from '../entities/employee-home';

@Injectable()
export class EmployeeHomeService extends BaseCrudService<EmployeeHome> {

  public uri = '/api/employeeHome/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeHomeService');
  }

  buildSentence(entity?: EmployeeHome, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
          `row${QueryOperator.Contain}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.address ?
          `address${QueryOperator.Contain}${entity.address}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCurrent ?
          `isCurrent${QueryOperator.Equal}${entity.isCurrent}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.apartmentNumber ?
          `apartmentNumber${QueryOperator.Contain}${entity.apartmentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.viaName ?
          `viaName${QueryOperator.Contain}${entity.viaName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.viaNumber ?
          `viaNumber${QueryOperator.Contain}${entity.viaNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.zoneName ?
          `zoneName${QueryOperator.Contain}${entity.zoneName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.interiorNumber ?
          `interiorNumber${QueryOperator.Contain}${entity.interiorNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.referenceDescription ?
          `referenceDescription${QueryOperator.Contain}${entity.referenceDescription}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.blockNumber ?
          `blockNumber${QueryOperator.Contain}${entity.blockNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.lotNumber ?
          `lotNumber${QueryOperator.Contain}${entity.lotNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.klmtNumber ?
          `klmtNumber${QueryOperator.Contain}${entity.klmtNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.blckNumber ?
          `blckNumber${QueryOperator.Contain}${entity.blckNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.stageNumber ?
          `stageNumber${QueryOperator.Contain}${entity.stageNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasMedicalCenter ?
          `hasMedicalCenter${QueryOperator.Equal}${entity.hasMedicalCenter}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.district && entity.district.id) {
        query = query.concat(
          `district.id${QueryOperator.Equal}${entity.district.id}${QueryOperator.Split}`
        );
      }
      if (entity.homeCondition && entity.homeCondition.id) {
        query = query.concat(
          `homeCondition.id${QueryOperator.Equal}${entity.homeCondition.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeRelative && entity.employeeRelative.id) {
        query = query.concat(
          `employeeRelative.id${QueryOperator.Equal}${entity.employeeRelative.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeRelative == null) {
        query = query.concat(
          `employeeRelative${QueryOperator.IsNull}${QueryOperator.Split}`
        );
      }
      if (entity.zoneType && entity.zoneType.id) {
        query = query.concat(
          `zoneType.id${QueryOperator.Equal}${entity.zoneType.id}${QueryOperator.Split}`
        );
      }
      if (entity.viaType && entity.viaType.id) {
        query = query.concat(
          `viaType.id${QueryOperator.Equal}${entity.viaType.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-home.service.ts